export const contactUsAction = ({ t, onContactUs, type = 'primary' }) => ({
    label: t('label_s200uki_contact_us'),
    icon: 'helpOutline',
    onClick: onContactUs,
    type,
});

export const primaryAction = ({ label, onClick, icon, isLoading, type = 'primary' }) => ({
    label,
    onClick,
    icon,
    isLoading,
    type,
});
